export default "__VITE_ASSET__3bc28f18__"